<template>
    <performance-common-dialog
        :title="'位置信息查看'"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'1300px'"
    >
        <template #top> </template>
        <template #table-list>
            <!-- 表格 -->
            <dispatch-position-table
                :componentsData="componentsData"
            ></dispatch-position-table>
            <!-- 表格 -->
        </template>
    </performance-common-dialog>
</template>
<script>
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import DispatchPositionTable from './DispatchPositionTable';

export default {
    name: 'dispatchOrder',
    components: { PerformanceCommonDialog, DispatchPositionTable },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            loading: false,
            totalData: [],
            pageTotal: 0,
            currentPage: 1,
            optionNum: 'SYS_WM_ASN_STATUS,SYS_WM_SO_STATUS'
        };
    },
    methods: {
        dialogClose () {
            this.$emit('components-close');
        }

    },
    mounted () {
        this.$refs.performanceCommonDialog.show();
    }

};
</script>

<style scoped lang="less">
/deep/.el-form-item {
    margin: 0;
    .el-form-item__label {
        padding: 0;
    }
}
/deep/.el-tabs__header {
    margin-bottom: 0px;
}
.tms-performance-dialog .main-list-info {
    margin-top: 0px;
    padding-top: 0px;
}
</style>
